import { useRef } from "react";
import SectionStoriesSlider from "./SectionStoriesSlider.tsx";

import StoriesModal, {
  StoriesModalRef,
} from "@/components/stories/StoriesModal.tsx";
import { useHomePage } from "@/pages/home/api";

const SectionStories = () => {
  const { data, isLoading } = useHomePage();

  const storiesModal = useRef<StoriesModalRef>(null);

  const showStories = (index: number) => {
    if (storiesModal.current) {
      storiesModal.current.openStories(index);
    }
  };

  return (
    <div>
      <SectionStoriesSlider
        showStory={showStories}
        slides={data?.stories ?? []}
        loading={isLoading}
      />
      {!isLoading && data?.stories && (
        <StoriesModal ref={storiesModal} storiesData={data?.stories} />
      )}
    </div>
  );
};

export default SectionStories;
